var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.184211,
    y: 0.184211,
    width: 27.6316,
    height: 27.6316,
    rx: 3.5,
    fill: "#F9F9FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.184211,
    y: 0.184211,
    width: 27.6316,
    height: 27.6316,
    rx: 3.5,
    stroke: "#D7D7D7",
    strokeWidth: 0.368421
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4288 19.1427V12.2856C17.4288 11.8309 17.2482 11.3949 16.9267 11.0734C16.6052 10.7519 16.1692 10.5713 15.7145 10.5713H8.85735C8.4027 10.5713 7.96666 10.7519 7.64517 11.0734C7.32368 11.3949 7.14307 11.8309 7.14307 12.2856V19.1427C7.14307 19.5974 7.32368 20.0334 7.64517 20.3549C7.96666 20.6764 8.4027 20.857 8.85735 20.857H15.7145C16.1692 20.857 16.6052 20.6764 16.9267 20.3549C17.2482 20.0334 17.4288 19.5974 17.4288 19.1427Z",
    stroke: "#848A9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4286 17.4287H19.1429C19.5976 17.4287 20.0336 17.248 20.3551 16.9265C20.6766 16.6051 20.8572 16.169 20.8572 15.7144V8.85979C20.8572 8.40514 20.6766 7.9691 20.3551 7.64761C20.0336 7.32612 19.5976 7.14551 19.1429 7.14551H19.1404L12.2832 7.15751C11.829 7.15819 11.3936 7.3391 11.0727 7.66052C10.7518 7.98194 10.5715 8.41758 10.5715 8.87179V10.5715M12.2858 13.1429V18.2858M14.8572 15.7144H9.71436",
    stroke: "#848A9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.7618663512ed64df39a352bece950301.svg";
export { ForwardRef as ReactComponent };